/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {

    import Client = Meevo.Model.Client;

    interface IAppointemntData {
        client: Client;
        details: IBookableDataRow;
    }

    class EnhancementsSlider implements ng.IComponentController {
        public static $inject = [
            'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskLogic'
        ];

        appointmentsData: IAppointemntData[];
        onReady: () => void;

        activeAppointmentData: IAppointemntData;

        rowIndex: number;

        constructor(protected selfCheckInKioskLogic: SelfCheckInKioskLogic) {
            this.appointmentsData = this.selfCheckInKioskLogic
                .clientDataToCheckin
                .reduce((all: IAppointemntData[], current: IDataToCheckInEntity) => {
                    for (const row of current.appointmentServicesToCheckIn) {
                        if (row.enhancements.length > 0) {
                            all.push({
                                client: current.client,
                                details: row
                            });
                        }
                    }

                    return all;
                }, []);

        }

        private selectNextActiveAppointment(): void {
            this.activeAppointmentData = this.appointmentsData[this.rowIndex++];

            if (this.activeAppointmentData) {
                this.activeAppointmentData.details.enhancements.forEach((enhancement) => {
                    const appointmentAddons = (this.activeAppointmentData.details.appointmentService.serviceAddOns || []);
                    enhancement.selected = appointmentAddons.filter((serviceAddon) => {
                        return enhancement.serviceId === serviceAddon.addOnServiceId;
                    }).length > 0;
                    enhancement.disabled = (typeof enhancement.extendedByStepMinutes === 'number'
                        && enhancement.extendedByStepMinutes > 0)
                        || enhancement.hasAddOnServiceEquipment
                        || enhancement.isRequired;
                });
            }

        }

        $onInit(): void {
            this.rowIndex = 0;

            this.selectNextActiveAppointment();
        }

        continue() {
            this.selectNextActiveAppointment();

            if (!this.activeAppointmentData) {
                this.onReady();
            }
        }

    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .component('scikEnhancementsSlider', <ng.IComponentOptions>{
            templateUrl: 'app/plugins/selfCheckInKiosk/components/enhancements-slider/enhancements-slider.html',
            controller: EnhancementsSlider,
            bindings: {
                appointmentsData: '<',
                onReady: '&'
            }
        });
}
